import { useState } from "react";
import { redirectNoticeCopy } from "@/config/whmcs";
import { analytics } from "@/lib/analytics";

/**
 * Wraps a WHMCS-bound link with a brief, dismissible confirmation so
 * visitors know they're leaving the marketing site for the billing portal.
 */
export function RedirectNotice({
  href,
  children,
  className,
  eventPayload,
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
  eventPayload?: Record<string, string>;
}) {
  const [pending, setPending] = useState(false);

  function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    analytics.track("whmcs_redirect", eventPayload);
    setPending(true);
    window.open(href, "_blank", "noopener,noreferrer");
    setTimeout(() => setPending(false), 1200);
  }

  return (
    <button onClick={handleClick} className={className} aria-live="polite">
      {pending ? "Redirecting to billing portal…" : children}
      <span className="sr-only">{redirectNoticeCopy}</span>
    </button>
  );
}
